import { Utilities } from '@shared/utilities/utilities.model';
import {ClaimSourceType} from './enums.model';

export class ClaimModel {
	complaint: Complaint;
	createdAt: string;
	damaged: Damage;
	id: string;
	practice_id: string;
	status: string;
	franchise_number: number;
	is_associable: boolean;
	authority_practice_linked: string[];
	event_description: string;
	claims_description: string;
	source_type: ClaimSourceType;
	allow_claims_operation: boolean;
	note?:string;

	constructor(model?: any) {
		this.complaint = new Complaint(model.complaint);
		this.createdAt = model.created_at;
		this.damaged = model.damaged ? new Damage(model.damaged) : null;
		this.id = model.id;
		this.practice_id = model.practice_id;
		this.status = model.claim_status;
		this.franchise_number = ![null, undefined].includes(model.franchise_number) ? model.franchise_number : 1;
		this.is_associable = model.is_associable;
		this.authority_practice_linked = model.authority_practice_linked;
		this.event_description = model.event_description;
		this.claims_description = model.claims_description;
		this.source_type = model.source_type;
		this.allow_claims_operation = model.allow_claims_operation;
		if (model.note) { this.note = model.note };
	}
}

export class Complaint {
	dataAccident: DataAccident;

	constructor(model?: any) {
	if (!Utilities.isVoid(model)) {
		this.dataAccident = new DataAccident(model.data_accident);
	}
	}
}

export class DataAccident {
	dateAccident: string;
	typeAccident: string;

	constructor(model?: any) {
		this.dateAccident = model.date_accident;
		this.typeAccident = model.type_accident;
	}
}

export class Damage {
	impactPoint: ImpactPoint;

	constructor(model?: any) {
		this.impactPoint = new ImpactPoint(model.impact_point);
	}
}

export class ImpactPoint {
	damageToVehicle: string;
	detectionsImpactPoint: string;
	incidentDescription: string;

	constructor(model?: any) {
		this.damageToVehicle = model.damage_to_vehicle;
		this.detectionsImpactPoint = model.detections_impact_point ? model.detections_impact_point : [];
		this.incidentDescription = model.incident_description;
	}
}

